import { useState } from 'react';
import { s3cloudUrl, siteUrl, strapiAdminUrl } from 'src/api/config';
import { Modal } from 'src/components/DialogComponent';
import ImagesList from 'src/components/ImagesList';
import { FileType } from 'src/types/main';
import { downloadForApp } from 'src/utils/downloadForApp';
import { isPWA } from 'src/utils/mobile';
import { BACKEND_URL, fetchFileBlob, fetchFilePreviewImages } from '../api/api';

const isCloudLink = (str: string) => str.includes(s3cloudUrl);

export const buildFileUrl5S = (url: string) =>
  isCloudLink(url) ? `${BACKEND_URL}/${new URL(url).pathname.slice(1)}` : `${BACKEND_URL}${url}`;

export const isImageUrl5S = (url: string | undefined) => !!url && /\.(jpe?g|gif|png)/i.test(url);

const saveBlob = (blob: Blob, name: string) => {
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = name;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
};

export function useFilePreview5SMobile() {
  const [images, setImages] = useState<string[]>([]);
  const [previewLoadingId, setPreviewLoadingId] = useState<number | null>(null);
  const [downloadingUrl, setDownloadingUrl] = useState<string | null>(null);

  const downloadFile = async (url: string | undefined, name?: string) => {
    if (!url || downloadingUrl) return;
    setDownloadingUrl(url);
    try {
      if (!isPWA()) {
        await downloadForApp({ FileRef: buildFileUrl5S(url), FileLeafRef: name || 'downloaded-file' } as FileType);
      } else {
        const { data } = await fetchFileBlob(buildFileUrl5S(url));
        saveBlob(data, name || 'downloaded-file');
      }
    } catch (e) {
      console.error('Не удалось скачать файл', e);
    } finally {
      setDownloadingUrl(null);
    }
  };

  const openPreview = (url: string | undefined, fileId?: number) => {
    if (!url) return;
    const fullUrl = buildFileUrl5S(url);
    if (isImageUrl5S(url)) {
      setImages([fullUrl]);
      return;
    }
    if (!fileId) return;
    setPreviewLoadingId(fileId);
    fetchFilePreviewImages(fileId, fullUrl.replace(siteUrl, strapiAdminUrl))
      .then(({ data }) => setImages(data.map((u: string) => `${siteUrl}${u}`)))
      .catch((e) => console.error('Не удалось открыть предпросмотр', e))
      .finally(() => setPreviewLoadingId(null));
  };

  const PreviewModal = (
    <Modal
      zIndex={130}
      open={images.length > 0}
      toggleDialog={() => setImages([])}
      modalClassName='w-[92vw] mx-auto min-h-0 flex flex-col gap-4 p-4 !pt-4'
      hideXMarkIcon
      closeOnBackdrop
    >
      <ImagesList images={images as any} />
      <button
        type='button'
        className='w-full py-3 rounded-md bg-darkblue text-white'
        onClick={() => setImages([])}
      >
        Закрыть
      </button>
    </Modal>
  );

  return { openPreview, previewLoadingId, downloadFile, downloadingUrl, PreviewModal };
}
